import { gql } from 'urql'

export const GET_RECONCILIATION_MATCH_PROGRESS = gql`
  query GetReconciliationMatchProgress($filter: ReconciliationProgressFilterInput) {
    reconciliationMatchProgress(filter: $filter) {
      items {
        periodKey
        periodLabel
        totalMovements
        segments {
          matchSource
          count
          percentage
        }
      }
      matchSources
      userRelatedOptions {
        userId
        displayName
        email
        firstName
        lastName
        matchesCount
      }
      totalMovements
    }
  }
`

export const GET_RECONCILIATION_TOP_AUTOMATIC = gql`
  query GetReconciliationTopAutomatic {
    reconciliationTopAutomatic {
      periodLabel
      items {
        companyId
        companyName
        totalMovements
        automaticMovements
        mixedMovements
        manualMovements
        notReconciledMovements
        automaticPercentage
        mixedPercentage
        manualPercentage
        notReconciledPercentage
      }
    }
  }
`

export const GET_RECONCILIATION_COMPANIES = gql`
  query GetReconciliationCompanies($search: String) {
    reconciliationCompanies(search: $search) {
      _id
      name
      rut
      alias
    }
  }
`
